import React from 'react';
const Step1Main = ({ setCurrentStep }) => {
   return (
      <div className="modal_content_body">
         <h3 className="ppt_form_title mb-5 text-center">Deposit</h3>
         <div className='ppt_deposit_ex text-center gap-3'>
            <div
               className='ppt_deposit_item anchor'
               onClick={() => setCurrentStep(2)}
            >
               <div className='ppt_deposit_item_imgs'>
                  <img src={process.env.PUBLIC_URL + '/assets/img/lm_icon_dollar.svg'} alt="" />
               </div>
               <p>Deposit<br />USD</p>
            </div>
            <div
               className='ppt_deposit_item anchor'
               onClick={() => setCurrentStep(3)}
            >
               <div className='ppt_deposit_item_imgs'>
                  <img src={process.env.PUBLIC_URL + '/assets/img/icon_propt_n.svg'} alt="" />
                  <img src={process.env.PUBLIC_URL + '/assets/img/icon_btc.svg'} alt="" />
                  <img src={process.env.PUBLIC_URL + '/assets/img/icon_usdc.svg'} alt="" />
               </div>
               <p>Deposit Crypto<br />and stablecoin</p>
            </div>
         </div>
      </div>
   );
};
export default Step1Main;